var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23470",
    "data-name": "Path 23470",
    d: "M-7690-2383a4.005,4.005,0,0,1-4-4v-10a4,4,0,0,1,4-4h4a4,4,0,0,1,4,4v1a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-1a2,2,0,0,0-2-2h-4a2,2,0,0,0-2,2v10a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2v-1a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1a4.006,4.006,0,0,1-4,4Zm10.293-4.292a1,1,0,0,1,0-1.413l2.292-2.294H-7689a1,1,0,0,1-1-1,1,1,0,0,1,1-1h11.588l-2.292-2.29a1,1,0,0,1,0-1.414,1,1,0,0,1,1.412,0l3.976,3.974a1.046,1.046,0,0,1,.166.2v0l.011.015s0,.008,0,.01l.006.01a.039.039,0,0,1,.008.016s0,0,0,0a.982.982,0,0,1,.122.473,1,1,0,0,1-.122.477,0,0,0,0,1,0,0,.061.061,0,0,1-.008.015l-.006.01,0,.01-.011.015v0a.99.99,0,0,1-.166.2l-3.976,3.978a.991.991,0,0,1-.7.294A1,1,0,0,1-7679.706-2387.292Z",
    transform: "translate(7694 2401)",
    fill: "#474a4e",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutIcon);
export default __webpack_public_path__ + "static/media/SignoutIcon.317df05edc08ec69052abb53ef3b8f17.svg";
export { ForwardRef as ReactComponent };